import script from "./Hello.vue?vue&type=script&setup=true&lang=js"
export * from "./Hello.vue?vue&type=script&setup=true&lang=js"

import "./Hello.vue?vue&type=style&index=0&id=3ba11bad&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ba11bad"]])

export default __exports__